import React, { useCallback, useEffect, useState } from "react";
import Cards from "common-ui-components/components/overview-cards/Cards";
import SeverityBreakdown from "./SeverityBreakdown";
import ThreatExposure from "./ThreatExposure";
import ThreatsDashboardPanels from "./ThreatsDashboardPanels";
import VulnerabilityMatrix from "./VulnerabilityMatrix";
import { VulnerabilityBarChart } from "../../../view/Vulnerabilities/VulnerabilitiesDashboard";
import HighRiskSoftwareOverview from "./HighRiskSoftwareOverview";
import styles from "./Threats.module.css";
import API from "common-ui-components/components/utils/API";

const getSummaryCards = (overview, loading) => {
  const count = (value) =>
    loading || value == null ? "--" : Number(value).toLocaleString();

  return [
    { title: "Total Open", value: count(overview?.totalVulnerabilities), color: "#1e293b" },
    { title: "Critical", value: count(overview?.totalCriticalVulnerabilities), color: "#dc2626" },
    { title: "High", value: count(overview?.totalHighVulnerabilities), color: "#d97706" },
    { title: "Zero-Day", value: count(overview?.totalZeroDayVulnerabilities), color: "#be185d" },
    { title: "Actively Exploited", value: count(overview?.totalActivelyExploitedVulnerabilities), color: "#2563eb" },
    // { title: "Past Due Remediation", value: count(overview?.totalPastDueRemediationVulnerabilities), color: "#b45309" },
  ];
};

const Threats = () => {
  const [overview, setOverview] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchOverview = useCallback(async (signal) => {
    try {
      const response = await API.get("/vulnerabilities/overview", { signal });
      if (!signal.aborted && response?.status?.success) {
        setOverview(response.body || {});
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error("Failed to load vulnerability overview:", error);
      }
    } finally {
      if (!signal.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchOverview(controller.signal);
    return () => controller.abort();
  }, [fetchOverview]);

  return (
    <div className={styles.threatsPage}>
      <Cards loading={loading} cards={getSummaryCards(overview, loading)} />
      <div className={styles.contentGrid}>
        <SeverityBreakdown overview={overview} loading={loading} />
        <ThreatExposure overview={overview} loading={loading} />
      </div>
      <div className={styles.trendsAndMatrix}>
        <VulnerabilityBarChart
          showModeSwitch={false}
          containerStyle={{ height: "34.3rem", minWidth: 0 }}
        />
        <VulnerabilityMatrix />
      </div>
      <ThreatsDashboardPanels />
      <HighRiskSoftwareOverview />
    </div>
  );
};

export default Threats;
